export default __webpack_public_path__ + "static/media/yugioh-hair.146a479f.png";